module.exports = __webpack_public_path__ + "static/media/ico-darkmode-dark.26940f83.svg";